import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import BannerApi from '@/api/common/banner';
import LogApi from '@/api/common/log';
import {isLogin, showMainBanner} from '@/utils/main';
import {SELECTED_MODE} from '@/constants/main';
import {ROUTE} from '@/constants/main/route';
import {
  BANNER_REQUEST_TYPE,
  BANNER_RESPONSE_TYPE,
} from '@/constants/main/banner';
import useMainStore from '@/stores/main';
import {Banner} from '@/components/common';
import PopularSection from '@/components/main/MyPlus/PopularSection';
import PreferSection from '@/components/main/MyPlus/PreferSection';

const formattedMainBanner = (banner) => {
  if (!banner || !banner.length === 0) {
    return [];
  }

  return banner.map((item) => {
    const {advertiser, adText, imageUrl, ...rest} = item;
    return {
      isBanner: true,
      thumbnailSrc: imageUrl, //썸네일
      title: adText, //광고제목
      userNickname: advertiser, //광고주
      ...rest,
    };
  });
};

/*
 *  prefer, popular - 메인 섹션 모든 컨텐츠 타입 컴포넌트 출력
 * */
const MainSection = ({selectedMode, mainListInfo, isSimplifyMode}) => {
  const location = useLocation();
  const mode = isLogin() ? selectedMode : SELECTED_MODE.POPULAR;
  //간소화 모드 여부 체크
  const {
    banner,
    checkAd,
    setBanner,
    resetBanner,
    isCloseMainBanner,
    setIsShowMainBanner,
    setIsCloseMainBanner,
  } = useMainStore();

  const getBanner = async () => {
    try {
      if (
        checkAd.AdParameter.hasOwnProperty('getAdParameters') &&
        checkAd.banners.bAdPcMainBanner
      ) {
        resetBanner(); // 241115 : 긴급수정 - 홈으로 되돌아 왔을때 트래킹URL이 갱신되지 않아 예전 트래킹 URL을 계속 호출하는 문제를 후루꾸로 처리함. 배너 광고 쪽 정리가 필요함. 함정카드가 많다.
        const params = checkAd.AdParameter.getAdParameters(
          BANNER_REQUEST_TYPE.MAIN_BANNER,
          {category: 'myplus'},
        );
        const res = await BannerApi.getBanner(params);
        if (res) {
          if (
            res.exist &&
            (res.type === BANNER_RESPONSE_TYPE.PC_MAIN_IMAGE ||
              res.type === BANNER_RESPONSE_TYPE.PC_MAIN_VIDEO)
          ) {
            setBanner({
              ...banner,
              main: {
                key: location.key,
                type: res.type,
                exist: res.exist,
                creatives: [...formattedMainBanner(res.creatives)],
              },
            });
            const adInfo = {
              func: 'getBanner',
              ad_type: res.type,
              location: 'main',
            };
            LogApi.sendTestAdInfoLog(adInfo);
          } else {
            //광고없음 상태일떄
            setIsShowMainBanner(false);
            setIsCloseMainBanner(true);
          }
        }
      }
    } catch (error) {
      setIsShowMainBanner(false);
      setIsCloseMainBanner(true);
      setBanner({
        ...banner,
        main: {
          key: '',
          type: '',
          exist: false,
          creatives: [],
        },
      });
    }
  };

  useEffect(() => {
    if (
      location.pathname === ROUTE.INDEX &&
      checkAd.banners?.bAdPcMainBanner &&
      banner.main?.key
    ) {
      getBanner();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (banner.main.exist && location.key === banner.main.key) {
      //노출 횟수 카운터에 체크
      const isShow = showMainBanner(checkAd.banners.bAdPcMainBannerCount);
      setIsShowMainBanner(isShow);
      //플로팅 배너 노출
      if (isShow) {
        setIsCloseMainBanner(false);
      }
      //플로팅 배너 비노출
      else {
        // 플로팅 배너 닫힌걸로 인식
        setIsCloseMainBanner(true);
      }
    }
  }, [banner.main]);

  return (
    <>
      {/* 해상도 축소에 따라 플로팅배너가 비노출되었을때, 기존 플로팅배너 DOM을 그대로 유지하고있어야해서(해상도 확대 시. 시청했던 시점부터 다시 광고 재생을 위해서) 실제로 플로팅 배너 닫기버튼을 클릭하지 않을 시에는 계속헤서 dom을 유지시킴 */}
      {!isCloseMainBanner && <Banner type={'main'} category={'myplus'} />}
      {/* 플로팅 배너 미노출 && 비쥬얼 영역이 로딩중(플로팅 배너가 노출되기 전에도 비쥬얼 영역이 노출되고 그 위를 플로팅배너가 덮이는 현상이 있어서)일때 노출  */}
      {mode === SELECTED_MODE.PREFER && (
        <>
          <PreferSection
            mainListInfo={mainListInfo}
            isSimplifyMode={isSimplifyMode}
          />
        </>
      )}
      {mode === SELECTED_MODE.POPULAR && (
        <>
          <PopularSection isSimplifyMode={isSimplifyMode} />
        </>
      )}
    </>
  );
};

export default MainSection;
